import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    // Auto-dismiss after 5 seconds if not closed manually
    this.timeout = setTimeout(() => {
      this.close()
    }, 5000)
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  close() {
    // Add fade out animation
    this.element.classList.remove('slide-in-from-top-2')
    this.element.classList.add('fade-out', 'slide-out-to-top-2')

    // Remove element after animation
    setTimeout(() => {
      this.element.remove()
    }, 300)
  }
}

